<template>
  <div>
    <Panel class="configurations" :title="$t('parameters')">
      <div class="columns">
        <div class="column">
          <div class="group">
            <label>{{$t('date')}}</label>
            <datetime
              v-model="parameters.date"
              :use12-hour="hourFormat == '12'"
              value-zone="local"
              :input-class="{invalid: $validate.error('parameters.date')}"
              input-style="width: 100%"
            />
          </div>
        </div>

        <div class="column"></div>
      </div>
      <button class="btn btn-primary" @click="generate">{{$t('generate')}}</button>
    </Panel>
    <Panel :title="$t('catering.delivery.report')">
      <RawTable v-if="tableData" :columns="tableData.columns" :rows="tableData.rows" :keyValueHeader="queryOptions"/>
      <div v-else>{{$t('when_no_report')}}</div>
    </Panel>
  </div>
</template>

<script>
  import RawTable from '@/components/RawTable.vue';
  import { mapActions } from "vuex";
  import moment from "moment-timezone";

  export default {
    name: "CateringDeliveries",

    components: { RawTable },

    data() {
      return {
        parameters: {
          date: moment().toISOString()
        },
        queryOptions: null,
        tableData: null
      }
    },

    computed: {
      branchId() {
        return this.$route.query.branch;
      },
      companyId() {
        return this.$route.query.company;
      },
      hourFormat() {
        if (this.$store.state.contextCompany) {
          return this.$store.state.contextCompany.hourFormat;
        }
        return "24";
      },
    },

    validate: {
      "parameters.date": {
        required: true
      }
    },

    methods: {
      ...mapActions(["reportCateringDeliveries"]),

      async generate() {

        if (!this.$validate.valid()) {
          this.$validate.validateAllOnce();
          return;
        }
        let options = Object.assign({branch: this.branchId, company: this.companyId}, this.parameters);
        let response = await this.reportCateringDeliveries({options});
        if (response) {
          this.tableData = response.data;
          this.queryOptions = response.query;
        } else {
          toast(this.$t('error.no_server'), 'error');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media print {
    .configurations {
      display: none !important;
    }
  }
</style>
